
// Get All
const ADMIN_GROUP_GET_ALL_DATA = {
  ADMIN_GROUP_GET_ALL_LOAD: "ADMIN_GROUP_GET_ALL_LOAD",
  ADMIN_GROUP_GET_ALL_SUCCESS: "ADMIN_GROUP_GET_ALL_SUCCESS",
  ADMIN_GROUP_GET_ALL_FAIL: "ADMIN_GROUP_GET_ALL_FAIL",
};
const ADMIN_GROUP_GET_ALL_API = "tickets/user-groups";

// Get By ID
const ADMIN_GROUP_GET_BY_ID_DATA = {
  ADMIN_GROUP_GET_BY_ID_LOAD: "ADMIN_GROUP_GET_BY_ID_LOAD",
  ADMIN_GROUP_GET_BY_ID_SUCCESS: "ADMIN_GROUP_GET_BY_ID_SUCCESS",
  ADMIN_GROUP_GET_BY_ID_FAIL: "ADMIN_GROUP_GET_BY_ID_FAIL",
};
const ADMIN_GROUP_GET_BY_ID_API = "tickets/user-groups/ ";

// Add
const ADMIN_GROUP_ADD_DATA = {
  ADMIN_GROUP_ADD_DATA_LOAD: "ADMIN_GROUP_ADD_DATA_LOAD",
  ADMIN_GROUP_ADD_DATA_SUCCESS: "ADMIN_GROUP_ADD_DATA_SUCCESS",
  ADMIN_GROUP_ADD_DATA_FAIL: "ADMIN_GROUP_ADD_DATA_FAIL",
};
const ADMIN_GROUP_POST_API = "tickets/user-groups";

// Update
const ADMIN_GROUP_UPDATE_DATA = {
  ADMIN_GROUP_UPDATE_DATA_LOAD: "ADMIN_GROUP_UPDATE_DATA_LOAD",
  ADMIN_GROUP_UPDATE_DATA_SUCCESS: "ADMIN_GROUP_UPDATE_DATA_SUCCESS",
  ADMIN_GROUP_UPDATE_DATA_FAIL: "ADMIN_GROUP_UPDATE_DATA_FAIL",
  ADMIN_GROUP_UPDATE_DATA_RESET: "ADMIN_GROUP_UPDATE_DATA_RESET",
};
const ADMIN_GROUP_PUT_API = "tickets/user-groups/";

// Delete
const ADMIN_GROUP_DELETE_DATA = {
  ADMIN_GROUP_DELETE_LOAD: "ADMIN_GROUP_DELETE_LOAD",
  ADMIN_GROUP_DELETE_SUCCESS: "ADMIN_GROUP_DELETE_SUCCESS",
  ADMIN_GROUP_DELETE_FAIL: "ADMIN_GROUP_DELETE_FAIL",
};
const ADMIN_GROUP_DELETE_API = "tickets/user-groups/";

//To Get ALL Admingroup ticketing
  const ADMIN_GROUP_GET_DATA = {
    ADMIN_GROUP_GET_DATA_LOAD: "ADMIN_GROUP_GET_DATA_LOAD",
    ADMIN_GROUP_GET_DATA_SUCCESS: "ADMIN_GROUP_GET_DATA_SUCCESS",
    ADMIN_GROUP_GET_DATA_FAIL: "ADMIN_GROUP_GET_DATA_FAIL",
  };

  const ADMIN_GROUP_GET_DETAIL_API = "tickets/user-groups/with-employees";

// Update Admin Flag
const ADMIN_GROUP_UPDATE_FLAG_DATA = {
  ADMIN_GROUP_UPDATE_FLAG_LOAD: "ADMIN_GROUP_UPDATE_FLAG_LOAD",
  ADMIN_GROUP_UPDATE_FLAG_SUCCESS: "ADMIN_GROUP_UPDATE_FLAG_SUCCESS",
  ADMIN_GROUP_UPDATE_FLAG_FAIL: "ADMIN_GROUP_UPDATE_FLAG_FAIL",
  ADMIN_GROUP_UPDATE_FLAG_RESET: "ADMIN_GROUP_UPDATE_FLAG_RESET",
};
const ADMIN_GROUP_UPDATE_FLAG_API = "tickets/user-groups/";

export {
  ADMIN_GROUP_GET_ALL_DATA,
  ADMIN_GROUP_GET_ALL_API,
  ADMIN_GROUP_GET_BY_ID_DATA,
  ADMIN_GROUP_GET_BY_ID_API,
  ADMIN_GROUP_ADD_DATA,
  ADMIN_GROUP_POST_API,
  ADMIN_GROUP_UPDATE_DATA,
  ADMIN_GROUP_PUT_API,
  ADMIN_GROUP_DELETE_DATA,
  ADMIN_GROUP_DELETE_API,
  ADMIN_GROUP_GET_DATA,
  ADMIN_GROUP_GET_DETAIL_API,
  ADMIN_GROUP_UPDATE_FLAG_DATA,
  ADMIN_GROUP_UPDATE_FLAG_API,
};